import { render, staticRenderFns } from "./returnPostage.vue?vue&type=template&id=ba150d72&"
import script from "./returnPostage.vue?vue&type=script&lang=js&"
export * from "./returnPostage.vue?vue&type=script&lang=js&"
import style0 from "./returnPostage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./returnPostage.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports